'use strict';

const EVcePositionerBase = require('../vce-positioner-base');

class EVcePositionerEditable extends EVcePositionerBase {
  init() {
    super.init();
    this.preventClickOutside = false;
    this._zIndex = 501;
    this._events.clickOutside = this._clickOutside.bind(this);
  }

  open(targetElement, iframe, borderColor = false) {
    super.open(targetElement, iframe, borderColor);
    this._closeEvents('add');
  }

  close() {
    if (!this._opened) {
      return;
    }

    this.dispatchEvent(new CustomEvent('close'));
    super.close();
    this._closeEvents('remove');
  }

  _mouseScroll() {
    super._mouseScroll();

    if (this._isDocumentsSame()) {
      return;
    }

    this._popper.update();
  }

  _isDocumentsSame() {
    return this.ownerDocument === this._targetElement.ownerDocument;
  }

  _closeEvents(action) {
    const eventListenerAction = action + 'EventListener';

    requestAnimationFrame(() => {
      this._iframeDocument.body[eventListenerAction]('click', this._events.clickOutside);
      this._iframeElement.ownerDocument.body[eventListenerAction]('click', this._events.clickOutside);
    });
  }

  _clickOutside(event) {
    if (this.preventClickOutside) {
      return;
    }

    const isElementToTarget = event.target === this._targetElement || this._targetElement.contains(event.target);
    const isPopperElement = this._popperElement && this._popperElement.contains(event.target);

    if (event.target === this || isElementToTarget || isPopperElement) {
      return;
    }

    this.close();
  }
}

module.exports = EVcePositionerEditable;
